var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-view',{attrs:{"title":_vm.title,"tips":_vm.tips},on:{"tip":_vm.tip}},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"label"},[_c('div',[_vm._v("正常")]),_c('div',[_vm._v("危险")])]),_c('span',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }